import api from './api';

export const getIntegrations = (page, params) => {
  return api.get('admin/Integration', { params: { page: page, limit: 5, ...params } });
};
